module.exports = __webpack_public_path__ + "static/media/waterfall.15767822.svg";